export default [
  {
    path: 'user/userRequest',
    component: () => import('@/views/userRequests/Wrapper.vue'),
    children: [
      {
        path: '',
        name: 'UserRequest',
        component: () => import('@/views/userRequests/search/Main.vue'),
      },
      {
        path: 'manageRequest/:id?',
        name: 'ManageRequest',
        component: () => import('@/views/userRequests/manage/UserAccountRequest.vue'),
      },
    ],
  },
];
